import React from 'react';
import { fetchGet, fetchPost, fetchPostPublic } from '@/utils/compiling';

import {
  // AllTemplates,
  AllMetas,
  AllComponents
} from 'utils/components';

/**
 * Will look and find the component wihtin a given list
 *
 * You can use it to find the components itself or its
 * metadata, for example.
 *
 * The priority order is:
 * - the specified package
 * - the local components
 * - a general compnoent
 * - the fallback (missing) component
 *
 * @param {Array} list The list where the component should be found
 * @param {String} pkg The name of the preffered package
 * @param {String} comp The name of the component
 * @returns Object The item found in the list, or null
 */
function findComponent(list, pkg, comp) {
  return list?.[pkg]?.[comp] ||
    list?.Local?.[comp] ||
    list?.General?.[comp] ||
    null;
}

function sectionsSorter(secA, secB) {
  return secA.order > secB.order ? 1 : -1;
}

export async function PageBuilder(page, settings = {}, theme = {}, breadcrumb) {

  const pageData = { page, settings, theme, breadcrumb };

  const promises = [];
  const tempSections = [];

  (pageData.page.sections || [])
    .sort(sectionsSorter)
    .forEach(sec => {

      if (sec.disabled) {
        return;
      }

      const MetaData = findComponent(AllMetas, sec.package, sec.component);

      if (!MetaData) {
        return;
      }

      const Meta = new MetaData();
      if (Meta.adapter && typeof Meta.adapter === 'function') {
        promises.push(async function () {
          const clonedSec = structuredClone(sec);
          try {
            const data = await Meta.adapter(
              clonedSec.contents,
              {
                settings: clonedSec.settings,
                // context: null,
                section: clonedSec,
                pageSettings: page
              },
              {
                get: fetchGet,
                post: fetchPost,
                publicPost: fetchPostPublic
              }
            );

            // sec.props = data;
            sec.contents = data;
            tempSections.push(sec);

          } catch (error) {
            console.log('\n');
            console.groupCollapsed("%cAdapter error: ", `
              padding: 10px;
              padding-right: 18px;
              background-color: red;
              color: white;
              font-weight: bold;
            `,
              `\n ├ Page: ${pageData.page.autopath}` +
              `\n ├ Section: ${sec.name}` +
              `\n ├ Package: ${sec.package || 'none'}` +
              `\n ├ Component: ${sec.component || 'none'}` +
              `\n ├ Error message:` +
              `\n | ${error.message || error.toString()}` +
              `\n | ` +
              `\n ├ Notice: This section will be removed from the page` +
              `\n └-------------------`
            );
          }
        }());
      } else {
        tempSections.push(sec);
      }
    });

  pageData.page.sections = tempSections;

  await Promise.all(promises).catch(errorInAdapter => {
  });

  return pageData;
}

function MissingComponent(props) {

  console.log('\n');
  console.groupCollapsed("%cMissing component: ", `
    padding: 10px;
    padding-right: 18px;
    background-color: ${props.componentName ? 'red' : 'yellow'};
    color: ${props.componentName ? 'white' : 'black'};
    font-weight: bold;
  `,
    (
      props.componentName
        ? props.componentName
        : 'no component selected'
    ),
    `\n ├ Page: ${props.page.autopath}` +
    `\n ├ Section: ${props.name}` +
    `\n ├ Package: ${props.packageName}` +
    `\n ├ Component: ${props.componentName || 'none'}` +
    `\n └-------------------`
  );

  console.groupEnd();

  return (
    <div></div>
  );
}

export function Section(props) {
  /* eslint-disable */
  const {
    data,
    idx,
    page,
    settings,
    theme,
  } = props;
  /* eslint-enable */

  const ComponentEl = React.useMemo(_ => {
    const Comp = AllComponents?.[data.package]?.[data.component] ||
      AllComponents?.Local?.[data.component] ||
      AllComponents?.General?.[data.component] ||
      null;

    const MetaData = AllMetas?.[data.package]?.[data.component] ||
      AllMetas?.Local?.[data.component] ||
      AllMetas?.General?.[data.component] ||
      null;

    const Meta = MetaData && new MetaData();

    return {
      Comp,
      Meta
    };
  }, [AllComponents]);

  if (!ComponentEl || !ComponentEl.Comp) {
    return <MissingComponent
      name={props.data.name}
      componentName={props.componentName}
      packageName={props.packageName}
      debug={props}
      page={page}
    />;
  }

  return (
    <ComponentEl.Comp
      {...(data?.contents || {})}
      // {...(data?.props || data?.contents || {})}
      {...(data?.settings || {})}
      globalSettings={settings}
      pageSettings={page}
    />
  );
}

function sectionSorter(A, B) {
  if (A.order > B.order) {
    return 1;
  }
  return -1;
}

export function Sections(props) {
  const {
    AllComponents,
    page,
    settings,
    theme,
    breadcrumb,
  } = props;

  return <>
    {
      page?.sections?.sort(sectionSorter)?.map((section, i) => {
        return (
          <Section
            key={section.name || i}
            AllComponents={AllComponents}
            componentName={section.component}
            packageName={section.package}
            data={section}
            idx={i}
            page={page}
            settings={settings}
            breadcrumb={breadcrumb}
            theme={theme}
          />
        );
      })
    }
  </>;
}





/* eslint-disable @typescript-eslint/no-explicit-any */
// import React from 'react';
// import { Logger, genericLocator, buildTemplateLocator, buildBlockBuilder } from '@on2-dev/on2-frontend-common/index.cjs';
// import { TemplateDependency } from '@on2-dev/on2-frontend-common/@types/templates';
// import * as TService_Templates from 'templates/_index';
// import * as TService_Blocks from 'components/_metas';
// import { MissingBlock } from 'components/_index';
// import * as General_Blocks from '@on2-dev/on2-general-resources/metas';

// const INTERNAL_TEMPLATES = {
//   TService: TService_Templates
// };

// const INTERNAL_BLOCKS = {
//   TService: TService_Blocks,
//   General: General_Blocks
// };

// export type RepoType = {
//   get: CallableFunction,
//   post: CallableFunction
// }

// export type PageBuilderDependency = TemplateDependency;

// type PageBuilderExtraOptions = {
//   repo: RepoType,
//   dependencies?: PageBuilderDependency[]
// }

// class PageBuilder {

//   protected readonly pageData: any;

//   protected templates: any;

//   protected blocks: any;

//   protected options: PageBuilderExtraOptions;

//   constructor(pageData: any, options: PageBuilderExtraOptions) {
//     this.pageData = pageData;
//     this.templates = INTERNAL_TEMPLATES;
//     this.blocks = INTERNAL_BLOCKS;
//     this.options = options;
//   }

//   public setTemplates(templates: any) {
//     this.templates = templates;
//     return this;
//   }

//   public setBlocks(blocks: any) {
//     this.blocks = blocks;
//     return this;
//   }

//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   public async page(context: any): Promise<any[]> {
//     const templateName = this.pageData?.template || 'PageTemplate';
//     const templateLocator = buildTemplateLocator(this.templates, 'TService');
//     const blockBuilder = buildBlockBuilder(this.blocks, MissingBlock, 'TService');
//     const templateConstructor = templateLocator(templateName);
//     const template = new templateConstructor(this.blocks, blockBuilder);

//     const dataFetcher = async (query: string, variables = {}) => {
//       return await this.options.repo.get(query, variables);
//     };

//     let data = [];

//     try {
//       data = await this.options.repo.get(template.queryBuilder(), { pageId: this.pageData.id });
//     } catch (error) {
//       Logger.error('[PageBuilder] Failed to query page data. Reason: ', error);
//       throw error;
//     }

//     context.page = this.pageData;
//     template.dependencies?.each((dependencyName: string) => {
//       if (!this.options.dependencies?.[dependencyName]) {
//         throw new Error(`[PageBuilder] Required Template dependency was not defined in options. Dependency: ${dependencyName}`);
//       }

//       context[dependencyName] = this.options.dependencies[dependencyName];
//     });

//     return await template.build(data, context, dataFetcher);
//   }
// }

// /**
//  * Construct a builder to Instantiate the React Component
//  *
//  * @param name The class name of wanted Component
//  * @param props Properties for component
//  */
// const buildComponentBuilder = (components: any) => {
//   const buildComponent = (name: string, key: string, props: any, children?: []) => {
//     let CustomComponent: any = MissingBlock;

//     try {
//       CustomComponent = genericLocator(name, components, 'Kinto');
//       if (!CustomComponent) {
//         Logger.debug(`[ComponentBuilder] Component with the name '${name}' not exists. Continuing with a empty placeholder.`);
//         CustomComponent = MissingBlock;
//       }
//     } catch (err) {
//       CustomComponent = MissingBlock;
//     }

//     const anchor = props?.anchor || key;

//     if (props.anchor) {
//       props = { ...props, style: { ...props.style, scrollMarginTop: '8rem' } };
//     }

//     if (!children || !children?.length) {
//       return <CustomComponent id={anchor} key={key} { ...props } />;
//     }

//     const builded = [];

//     children.forEach((tuple: any, idx: number) => {
//       builded.push(buildComponent(tuple?.component, `${key}-children-${idx}`, tuple?.props, tuple?.children || []));
//     });

//     return <CustomComponent id={anchor} key={key} { ...props }>{builded}</CustomComponent>;
//   };

//   return buildComponent;
// };

// export { PageBuilder, buildComponentBuilder };
